// on importe le controller car les components angularJS
// permettent l'ajout direct d'une fonction dans la propriété "controller"
import DocumentCaracteristiquesController from './document.form.caracteristiques.controller';
import Template from './document.form.caracteristiques.html';

export default {
	bindings: {
		// on bind avec '=' (double binding)
		// quand on veut pouvoir modifier l'objet des deux cotés (appelant et component)
		document: '=',
		// on bind avec '<' (binding one way)
		// quand on ne veut pas pouvoir modifier l'objet dans le component (seulement dans l'appelant)
		typeId: '<',
		onUpdate: '&',
		form: '=',
		onCaracteristiquesCount: '&'
	},
	template: Template /* require('./document.form.caracteristiques.html') */,
	controller: DocumentCaracteristiquesController
	// si on ne déclare pas de 'controllerAs', par défaut ce sera '$ctrl'
};
